import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { auth, db } from '../services/firebase';
import { toast, ToastContainer } from 'react-toastify';
import { FaArrowLeft } from 'react-icons/fa';
import SearchActivityForm from '../components/SearchActivityForm';
import SimpleNavHeader from '../components/SimpleNavHeader';

import 'react-toastify/dist/ReactToastify.css';




function CreateSearchActivityPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    activityType: 'bar or restaurant',
    radius: 5,
    dateRange: [null, null],
    hourRange: ['', ''],
    numberOfPeople: 4
  });
  const [position, setPosition] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setPosition({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude
        });
      },
      (err) => {
        console.warn('Geolocation error:', err);
      },
      { enableHighAccuracy: true }
    );
  }, []);




  const handleCreate = async (e) => {
    e.preventDefault();

    let [startDate, endDate] = formData.dateRange;
    const [hourFrom, hourTo] = formData.hourRange;

    // Auto-fill endDate if it's null
    if (startDate && !endDate) {
      endDate = startDate;
    }

    // Check if hourTo is earlier than hourFrom
    if (hourFrom && hourTo && hourTo < hourFrom) {
      toast.error('End time cannot be earlier than start time.', {
        position: 'top-center',
        autoClose: 3000
      });
      return;
    }

    if (!position) {
      toast.error('Target location is required. Please select a location on the map.', {
        position: 'top-center',
        autoClose: 3000
      });
      return;
    }

    const user = auth.currentUser;
    if (!user) return;

    setLoading(true);

    const newSearch = {
      ownerId: user.uid,
      activityType: formData.activityType,
      preferredLocation: {
        lat: position.lat,
        lng: position.lng
      },
      preferredRadiusKm: parseInt(formData.radius),
      preferredTime: {
        dateRange: {
          from: startDate.toLocaleDateString('sv-SE'), // because they use 'YYYY-MM-DD' format
          to: endDate.toLocaleDateString('sv-SE')
        },
        hourRange: {
          from: hourFrom,
          to: hourTo
        }
      },
      numberOfPeople: formData.numberOfPeople,
      status: 'pending',
      createdAt: Timestamp.now()
    };

    try {
      await addDoc(collection(db, 'search_activities'), newSearch);
      navigate('/home');
    } catch (error) {
      console.error('Error creating search activity:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex align-items-center mb-4">
        <button
          type="button"
          className="btn btn-outline-primary me-3 d-flex align-items-center"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft className="me-2" />
          Back
        </button>
        <h4 className="mb-0">Create New Search</h4>
      </div>


      {/* <SimpleNavHeader
        header_text="Create New Search"
        subtitle="Online • Last seen 2m ago"
        sticky
        transparent={false}   // set true if you want it to blend into a hero
        showDivider={true}
      /> */}


      <ToastContainer />

      <SearchActivityForm
        formData={formData}
        setFormData={setFormData}
        position={position}
        setPosition={setPosition}
        handleSubmit={handleCreate}
        loading={loading}
      />



    </div>
  );
}

export default CreateSearchActivityPage;
